import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes:[
        {
            path: "/",
            name: "Home",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/Home.vue"
                )
        },
        {
            path: "/Profile",
            name: "Profile",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/Profile.vue"
                )
        },
        {
            path: "/List",
            name: "List",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/List.vue"
                )
        },
        {
            path: "/Join",
            name: "Join",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/Join.vue"
                )
        },
        {
            path: "/Mailehui",
            name: "Mailehui",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/Mailehui.vue"
                )
        },{
            path: "/Maixueyuan",
            name: "Maixueyuan",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/Maixueyuan.vue"
                )
        },{
            path: "/Contact",
            name: "Contact",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/Contact.vue"
                )
        },{
            path: "/Details",
            name: "Details",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/Details.vue"
                )
        },
        {
            path: "/RuJiaCulture",
            name: "RuJiaCulture",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/RuJiaCulture.vue"
                )
        },
        {
            path: "/MaiJiaAdvertising",
            name: "MaiJiaAdvertising",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/MaiJiaAdvertising.vue"
                )
        },{
            path: "/MaiJiaCaseDetail",
            name: "MaiJiaCaseDetail",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/MaiJiaCaseDetail.vue"
                )
        },{
            path: "/MaiJiaCaseList",
            name: "MaiJiaCaseList",
            component: () =>
                import(
                    /* webpackChunkName: "group-foo" */ "@/views/MaiJiaCaseList.vue"
                )
        },
    ],
})